function syncHeaderWrapperBackground(wrapper) {
  const transparentAtTop = wrapper.getAttribute('data-transparent-at-top') === 'true';
  const darkHeader = wrapper.getAttribute('data-dark-header') === 'true';
  const headerTheme = wrapper.getAttribute('data-header-theme');
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const atTop = scrollTop <= 0;

  if (headerTheme === 'learning-center') {
    if (atTop) {
      wrapper.classList.add('header-wrapper--transparent');
      wrapper.classList.remove('header-wrapper--lovoi-black', 'header-wrapper--lovoi-ivory');
    } else {
      wrapper.classList.remove('header-wrapper--transparent');
      wrapper.classList.add('header-wrapper--lovoi-black');
      wrapper.classList.remove('header-wrapper--lovoi-ivory');
    }
    wrapper.classList.add('header-wrapper--on-dark');
    return;
  }

  if (transparentAtTop) {
    if (atTop) {
      wrapper.classList.add('header-wrapper--transparent');
      wrapper.classList.remove('header-wrapper--lovoi-ivory', 'header-wrapper--lovoi-black');
    } else {
      wrapper.classList.remove('header-wrapper--transparent');
      wrapper.classList.add('header-wrapper--lovoi-ivory');
      wrapper.classList.remove('header-wrapper--lovoi-black');
    }
  }

  if (darkHeader) {
    if (atTop && wrapper.classList.contains('header-wrapper--transparent')) {
      wrapper.classList.add('header-wrapper--on-dark');
    } else if (headerTheme !== 'learning-center') {
      wrapper.classList.remove('header-wrapper--on-dark');
    }
  }
}

class StickyHeader extends HTMLElement {
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    if (!this.header) return;

    this.transparentAtTop = this.getAttribute('data-transparent-at-top') === 'true';
    this.darkHeader = this.getAttribute('data-dark-header') === 'true';
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerOffset = 0;

    this.setHeaderHeight();
    requestAnimationFrame(() => this.setHeaderHeight());

    this.onResizeHandler = this.setHeaderHeight.bind(this);
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.onResizeHandler);
    window.addEventListener('resize', this.onResizeHandler, { passive: true });

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.keepHeaderVisible = !!document.querySelector('.lovoi-legal-policy');
    this.predictiveSearch = this.querySelector('predictive-search');

    if (this.keepHeaderVisible && this.header.classList.contains('shopify-section-header-hidden')) {
      requestAnimationFrame(this.reveal.bind(this));
    }

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });

    syncHeaderWrapperBackground(this);
  }

  setHeaderHeight() {
    if (!this.header) return;
    const height = this.header.offsetHeight;
    this.headerOffset = height;
    document.documentElement.style.setProperty('--header-height', `${height}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
    window.removeEventListener('resize', this.onResizeHandler);
  }

  syncHeaderBackground() {
    syncHeaderWrapperBackground(this);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const headerOffset = this.headerOffset || this.header.offsetHeight;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > headerOffset) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide || this.keepHeaderVisible) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > headerOffset) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        if (!this.keepHeaderVisible) {
          requestAnimationFrame(this.hide.bind(this));
        }
      }
    } else if (scrollTop <= headerOffset) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
    this.syncHeaderBackground();
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    this.syncHeaderBackground();
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    if (this.searchModal) this.searchModal.close(false);
  }
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}

function initStaticHeaderTransparentScroll() {
  const wrapper = document.querySelector('[data-transparent-at-top]:not(sticky-header)');
  if (!wrapper) return;

  function syncHeaderBackground() {
    syncHeaderWrapperBackground(wrapper);
  }

  window.addEventListener('scroll', syncHeaderBackground, { passive: true });
  window.addEventListener('pageshow', syncHeaderBackground);
  syncHeaderBackground();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStaticHeaderTransparentScroll);
} else {
  initStaticHeaderTransparentScroll();
}
